export default {"src":"/_next/static/media/chevronRight.f31f21c3.svg","height":8,"width":5};